import React, { FC } from 'react'

import { useRouter } from 'next/navigation'

import { Icon, Tag, Txt } from 'src/components/atoms'

import { Routes } from 'src/routes'

type Props = {
  userName: string
  userType: 'internal' | 'external'
  className?: string
}

export const UserBreadcrumb: FC<Props> = ({ userName, userType, className }) => {
  const router = useRouter()

  return (
    <div className={className}>
      <div className="tw-flex tw-items-center tw-gap-r-3">
        <div
          role="presentation"
          onClick={() =>
            userType === 'internal'
              ? router.push(Routes.UserList.path)
              : router.push(Routes.ExternalUserList.path)
          }
          className="tw-cursor-pointer tw-text-standardText-secondary"
        >
          <Icon path="users/soft/line" size="--r0" />
        </div>
        <Icon path="chevron-right/soft/line" className="tw-text-standardText-disable" />
        <Txt sizeType="s" className="tw-text-correctGreen-default tw-font-bold">
          {userName}
        </Txt>

        {userType === 'external' && (
          <Tag size="s" type="secondary" state="outline">
            社外ユーザー
          </Tag>
        )}
      </div>
    </div>
  )
}
